import AdBanner from '../../../common/component/AdBanner';
import {REGION} from '../../../common/constant';
import {IAdBanner} from '../../../common/type';
import {sendHomeEvent, sendHomeViewImp} from '../../common/tracking';

interface IProps {
  talkBoard?: IAdBanner;
  onLoadMoment?: () => void;
}

export default function DaysTalkBoardV4({talkBoard, onLoadMoment}: IProps) {
  if (REGION !== 'kor') {
    return null;
  }

  if (!talkBoard) {
    return <div className="bg-background h-68" />;
  }

  return (
    <AdBanner
      banner={talkBoard}
      onLoadMoment={onLoadMoment}
      onIntersection={isIntersecting => {
        isIntersecting &&
          sendHomeViewImp({
            customProps: {
              event_layer: 'banner',
              cardgroup_id: talkBoard.cardgroupId,
            },
          });
      }}
      onClick={(_, id) => {
        sendHomeEvent({
          actionName: 'banner',
          action: 'click',
          customProps: {
            event_layer: 'banner',
            banner_id: id,
            cardgroup_id: talkBoard.cardgroupId,
          },
        });
      }}
    />
  );
}
